export enum EstadoMovimientoBeca {
  CAPTURADO = 'CAPTURADO',
  EN_REVISION = 'EN_REVISION',
  AUTORIZADO = 'AUTORIZADO',
  RECHAZADO = 'RECHAZADO',
  APLICADO = 'APLICADO',
  NO_APLICADO = 'NO_APLICADO',
  REVISADO = 'REVISADO',
  SOLICITADO = 'SOLICITADO',
  PRE_AUTORIZADO = 'PRE_AUTORIZADO',
  PENDIENTE = 'PENDIENTE',
  LINEA_CAPTURA = 'LINEA_CAPTURA',
  PROGRAMADO = 'PROGRAMADO',
  ACTIVADO = 'ACTIVADO',
  CONCLUIDO = 'CONCLUIDO',
}

export const obtenerEstadosMovimientoPagoPeriodico = (): {
  value: EstadoMovimientoBeca;
  nombre: EstadoMovimientoBeca;
  text: EstadoMovimientoBeca;
}[] => {
  const estados = [EstadoMovimientoBeca.PROGRAMADO, EstadoMovimientoBeca.ACTIVADO, EstadoMovimientoBeca.CONCLUIDO];

  return estados.map(tipo => ({
    value: tipo,
    nombre: tipo,
    text: tipo,
  }));
};
